"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const parseCommonNode_1 = __importDefault(require("./parseCommonNode"));
function parseScalarNode(node) {
    return Object.assign({ kind: "scalar" }, parseCommonNode_1.default(node));
}
exports.default = parseScalarNode;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGFyc2VTY2FsYXJOb2RlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL3YyL3BhcnNlcnMvZ2ZTZGwvcGFyc2VTY2FsYXJOb2RlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O0FBRUEsd0VBQWdEO0FBRWhELFNBQXdCLGVBQWUsQ0FDckMsSUFBOEI7SUFFOUIsdUJBQ0UsSUFBSSxFQUFFLFFBQVEsSUFDWCx5QkFBZSxDQUFDLElBQUksQ0FBQyxFQUN4QjtBQUNKLENBQUM7QUFQRCxrQ0FPQyJ9